export const SIGN_DOC_SIGN_PAD_DIMS = { x: 250, y: 80 }
